import * as React from "react";
function SvgReportsSocialperf(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 200 200"
      ref={svgRef}
      {...props}
    >
      <path d="M178.8 0h-57.1l28.5 28.6L114 64.8l-42-42-72 72v42.4l72-72 42 42 57.4-57.4L200 78.3V0h-21.2z" />
      <path d="M0 151.2V200h38v-86.8l-38 38zM72 79.2l-18 18V200h38V99.2l-20-20zM114 121.2l-6-6V200h38V89.2l-32 32zM162 73.2V200h38V92.3l-28.6-28.5-9.4 9.4z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgReportsSocialperf);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
